module.exports = __webpack_public_path__ + "img/Receiving-m.a8b95d12.png";